<template>
  <div class="systemDoorDetail">
    <div class="systemDoorDetailBox">
      <el-row>
        <el-col :span="22">查看门店详情</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>
      <div class="detailBox">
        <div class="line">
          <label>门店名称</label>
          <span>{{detailData.doorName}}</span>
        </div>
        <div class="line">
          <label>区域</label>
          <span>{{detailData.regionName}}</span>
        </div>
        <div class="line">
          <label>城市</label>
          <span>{{detailData.cityName}}</span>
        </div>
        <div class="line">
          <label>客户</label>
          <span>{{detailData.resellerName}}</span>
        </div>
        <div class="line">
          <label>等级</label>
          <span>{{detailData.concept}}</span>
        </div>
      </div>
      <footer>
        <el-button type="success" @click="goBack()">
          关 闭
        </el-button>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "SystmenDoorDetail",
  data() {
    return {
      id: this.$route.query.id,
      detailData: {
        doorName: '',
        regionName: '',
        cityName: '',
        resellerName: '',
        concept: '',
      }
    }
  },
  mounted() {
    if (this.id) {
      this.getData()
    }
  },
  methods: {
    async getData() {
      // todo: 获取数据
      let res = await axios.post(oprReqUrl+"door/" + this.id);
      if (res.data.code === 200) {
        this.detailData = res.data.data
        console.log('this.detailData', this.detailData)
      }
    },
    goBack() {
      this.$router.push({ path: '/pages/systemDoor' });
    }
  }
};
</script>
<style lang="sass" scoped>
.systemDoorDetail
  min-width: 800px
  .systemDoorDetailBox
    padding: 20px
    .detailBox
      width: 50%
      margin-left: 25%
      margin-top: 20px
      margin-bottom: 20px
      .line
        height: 60px
        line-height: 60px
        font-size: 14px
        color: #707070
        border-bottom: 1px solid #ccc
        display: flex
        label
          color: #a8a8a8
          width: 25%
    footer
      padding-top: 30px
      text-align: center

</style>



// WEBPACK FOOTER //
// src/opr/pages/views/systemDoorDetail.vue